const clearSessionStorage = (): void => {
  const correlationId = sessionStorage.getItem('correlationId')
  sessionStorage.clear()
  sessionStorage.setItem('correlationId', correlationId)
}

export default clearSessionStorage
